import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/disallowed")({
  component: RouteComponent,
  staticData: {
    permissionGuards: [
      {
        resource: "nonexistent",
        actions: ["nothing"],
      },
    ],
  },
});

function RouteComponent() {
  return <div>Hello "/demo/disallowed"!</div>;
}
